import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { ContenuSite } from '../models/contenu-site.model';

@Injectable({
  providedIn: 'root'
})
export class ContenuSiteService {

  private apiUrl = 'https://be.festivalsousse.com/api/contenu';

  // Cache local charge une fois au demarrage du site, utilise par le pipe "contenu"
  // pour un acces synchrone et instantane dans les templates (pas de flash de texte vide).
  private cache: Record<string, ContenuSite> = {};
  private chargeAuMoinsUneFois = false;

  constructor(private http: HttpClient) { }

  charger(): Observable<ContenuSite[]> {
    return this.http.get<ContenuSite[]>(this.apiUrl).pipe(
      tap(blocs => {
        this.cache = {};
        blocs.forEach(b => this.cache[b.cle] = b);
        this.chargeAuMoinsUneFois = true;
      })
    );
  }

  estCharge(): boolean {
    return this.chargeAuMoinsUneFois;
  }

  obtenir(cle: string): ContenuSite | null {
    return this.cache[cle] || null;
  }

  // Utilise par l'admin pour afficher/editer tous les blocs regroupes par page
  obtenirTous(): Record<string, ContenuSite> {
    return this.cache;
  }

  enregistrerTous(blocs: ContenuSite[]): Observable<ContenuSite[]> {
    return this.http.put<ContenuSite[]>(this.apiUrl, blocs).pipe(
      tap(resultat => {
        this.cache = {};
        resultat.forEach(b => this.cache[b.cle] = b);
      })
    );
  }
}
